import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import './Navbar.css';
import Header from './Header';
import LogoutButton from './common/LogoutButton';

function Navbar({ firstName = '', lastName = '', onLogout }) {
  const fullName = `${firstName} ${lastName}`.trim();

  return (
    <div>
      <Header />
      <nav className="navbar">
        <div className="navbar-links">
          <NavLink
            to="/dashboard"
            className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}
            end
          >
            Dashboard
          </NavLink>
          <NavLink
            to="/upload"
            className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}
          >
            Upload Files
          </NavLink>
          <NavLink
            to="/upload-history"
            className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}
          >
            Upload History
          </NavLink>
          <NavLink
            to="/support"
            className={({ isActive }) => isActive ? "nav-btn active" : "nav-btn"}
          >
            Support
          </NavLink>
        </div>
        <div className="navbar-user">
          Welcome,{' '}
          <span
            className="navbar-user-name"
            title={fullName || undefined}
          >
            {firstName} {lastName}
          </span>
          {' '}|{' '}
          <LogoutButton 
            className="logout-btn"
            onLogoutComplete={onLogout}
          />
        </div>
      </nav>
    </div>
  );
}

Navbar.propTypes = {
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  onLogout: PropTypes.func
};

export default Navbar;